import { Breakpoints, styled } from '@vw-marketing/us-components';

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${(props) => props.openContentLayer && '0 31px'};
  width: 100%;

  @media (min-width: ${Breakpoints.b960}px) {
    padding: ${(props) => props.openContentLayer && '0 64px'};
  }
`;

export const StyledServicesList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.size.static200};
`;

export const StyledTwoColumnServicesList = styled.div`
  display: grid;
  gap: ${(props: any) => props.theme.size.static200};
  grid-auto-rows: 1fr;
  grid-template-columns: 1fr 1fr;
`;

export const StyledMaintenanceServicesHeadline = styled.div`
  ${({ theme }) => {
    return `
      align-items: center;
      align-self: stretch;
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: ${theme.size.static400} ${theme.size.static350};

      p {
        color: ${theme.colors.content.primary};
      }

      p + p {
        color: ${theme.colors.content.tertiary};
      }
    `;
  }}
`;

export const StyledServicesHeadline = styled.div`
  ${({ theme }) => {
    return `
      align-items: center;
      align-self: stretch;
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: ${theme.size.static350};

      p {
        color: ${theme.colors.content.primary};
      }

      p + p {
        color: ${theme.colors.content.tertiary};
      }
    `;
  }}
`;

export const StyledServicesItemContainer = styled.div`
  align-items: flex-start;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: ${(props: any) => props.theme.size.static200};
  height: 100%;

  hr {
    width: 100%;
  }
`;

export const StyledServicesItem = styled.div`
  ${({ theme, isAdditionalService }) => {
    return `
      align-items: flex-start;
      align-self: stretch;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      height: 100%;
      min-height: 29px;
      padding: ${!isAdditionalService ? `0px ${theme.size.static300} 0px 31px` : `${theme.size.static200} 31px`};

      & > * {
        flex: 1;
      }

      p {
        color: ${theme.colors.content.primary};
      }

      p + p {
        color: ${theme.colors.content.secondary};
      }
    `;
  }}
`;
